import wx from './jweixin1.6.0.js';
import http, {appId} from './http'
import utils from './utils'

class WxShare {
  constructor() {
    this.init()
  }
  init() {
    if (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()) {
      http.get('/user/getShareSign', {
        params: {
          appid: appId,
          url: encodeURIComponent(window.location.href.split('#')[0])
        }
      }).then(res => {
        let data = res.data || {}
        wx.config({
          debug: false,
          appId: appId,
          timestamp: data.timestamp,
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: [
            'checkJsApi',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline'
          ]
        })
      })
    }
  }
  share(shareData) {
    wx.ready(() => {
      /*let shareData = {
      	title: obj.title, //标题
      	desc: summary, //描述
      	link: window.location.href, //链接(不包括hash)
      	imgUrl: pic //图片(绝对路径)
      };*/
      let checkList = ['updateAppMessageShareData', 'updateTimelineShareData'];
      for (let api of checkList) {
        wx[api](shareData)
      }
    })
  }
}

export class WxOpenTag {
  constructor() {
    this.init()
  }
  init() {
    if (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()) {
      http.get('/user/getShareSign', {
        params: {
          appid: appId,
          url: encodeURIComponent(window.location.href.split('#')[0])
        }
      }).then(res => {
        let data = res.data
        wx.config({
          debug: false,
          appId: appId,
          timestamp: data.timestamp,
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: [],
          openTagList: ['wx-open-launch-app']
        })
      })
    }
  }
}

export default WxShare
